import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, Phone, MessageCircle } from 'lucide-react';
import { Button } from './ui/button';

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { name: 'Services', path: '/services' },
    { name: 'Reviews', path: '/reviews' },
    { name: 'FAQ', path: '/faq' },
    { name: 'Contact Us', path: '/contact' }
  ];

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white shadow-md' : 'bg-transparent'
        }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-0">
            <img
              src="/LOGO5.png"
              alt="Royal Shine Logo"
              className="h-10 w-auto"
            />
            <div className="flex flex-col leading-none">
              <span
                className="text-2xl font-bold text-royalBlue"
                style={{ fontFamily: 'Klavika, Helvetica, Arial, sans-serif', fontWeight: 700 }}
              >
                oyal <span className="text-royalBlue">Shine</span>
              </span>
              <span className="-mt-1 text-[10px] sm:text-xs text-slate-500 whitespace-nowrap">
                Trusted Excellnce in Cleaning
              </span>
            </div>


          </Link>


          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`text-sm font-medium transition-colors hover:text-blue-600 ${location.pathname === link.path
                  ? 'text-blue-600'
                  : 'text-slate-700'
                  }`}
              >
                {link.name}
              </Link>
            ))}
            <Button asChild size="lg" className="bg-blue-600 hover:bg-blue-700">
              <Link to="/book">Book Now</Link>
            </Button>
            <Button
              asChild
              variant="outline"
              size="lg"
              className="border-blue-600 text-blue-600 hover:bg-blue-50"
            >
              <a href="tel:+61451233795">
                <Phone className="w-4 h-4 mr-2" />
                +61 451 233 795
              </a>
            </Button>
            <Button
              asChild
              variant="outline"
              size="lg"
              className="border-green-600 text-green-600 hover:bg-green-50"
            >
              <a href="https://wa.me/61408223940" target="_blank" rel="noopener noreferrer">
                <MessageCircle className="w-4 h-4 mr-2" />
                WhatsApp
              </a>
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden p-2"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            {isMobileMenuOpen ? (
              <X className="w-6 h-6 text-slate-900" />
            ) : (
              <Menu className="w-6 h-6 text-slate-900" />
            )}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="md:hidden bg-white border-t">
          <div className="px-4 py-6 space-y-4">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`block text-base font-medium transition-colors ${location.pathname === link.path
                  ? 'text-blue-600'
                  : 'text-slate-700'
                  }`}
                onClick={() => setIsMobileMenuOpen(false)}
              >
                {link.name}
              </Link>
            ))}
            <Button asChild size="lg" className="w-full bg-blue-600 hover:bg-blue-700">
              <Link to="/book" onClick={() => setIsMobileMenuOpen(false)}>
                Book Now
              </Link>
            </Button>
            <Button
              asChild
              variant="outline"
              size="lg"
              className="w-full border-blue-600 text-blue-600"
            >
              <a href="tel:+61451233795">
                <Phone className="w-4 h-4 mr-2" />
                +61 451 233 795
              </a>
            </Button>
            <Button
              asChild
              variant="outline"
              size="lg"
              className="w-full border-green-600 text-green-600"
            >
              <a href="https://wa.me/61408223940" target="_blank" rel="noopener noreferrer">
                <MessageCircle className="w-4 h-4 mr-2" />
                WhatsApp
              </a>
            </Button>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
